import { TOKEN_MODEL_KEY_POINTER } from 'models/daos/token/constants'

const TOKENS_DOMAIN = 'tokens'
const TOKENS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  new: null
}

const TOKENS_DOMAIN_MAP_KEY = TOKEN_MODEL_KEY_POINTER

const TOKENS_PATH = {
  DATA: `${TOKENS_DOMAIN}.data`,
  NEW: `${TOKENS_DOMAIN}.new`
}

export {
  TOKENS_DOMAIN,
  TOKENS_DOMAIN_MAP_KEY,
  TOKENS_STATE,
  TOKENS_PATH
}
